import { escapeStringRegExp } from "seneca-common/utils/functions/escapeStringRegExp";

import { evaluate } from "../../generation/evaluate";
import { isSelectInput } from "../typeGuards";
import { extractStatementParts } from "./extractHelpers";

export function processStatements(
  scope: any,
  template: string,
  performEvaluation: boolean = true
) {
  const statements = extractStatementParts(template);

  return statements
    .reduce((acc, statement) => {
      const evaluated = performEvaluation
        ? evaluate(scope, statement.statement)
        : statement.statement;
      if (isSelectInput(evaluated)) {
        return acc.replace(
          new RegExp(escapeStringRegExp(statement.original)),
          evaluated.correctValue?.toString()
        );
      }
      return acc.replace(
        new RegExp(escapeStringRegExp(statement.original)),
        evaluated?.toString()
      );
    }, template)
    .replaceAll("`", ""); // to be able to write 3x as $b`x and not confuse with a 'bx' variable
}
